import ResolvedNodeDTO = Modules.BasePrice.Data.Resolved.ResolvedNodeDTO;

export type BudgetAllocationIssue = "over" | "under";

/**
 * Which way a node's budget_fully_allocated flag fails. The flag itself is
 * just a bool, but fixed shares are never capped, so `budget` (what the node
 * resolves to) climbs past `allotted_budget` (what it was handed) exactly
 * when they over-commit it, and stays below when nothing free is left to
 * take up the rest. Same euro of rounding slack as the backend's check.
 */
export const budgetAllocationIssue = (
	node: Pick<ResolvedNodeDTO, "budget" | "allotted_budget" | "budget_fully_allocated">
): BudgetAllocationIssue | null => {
	if (node.budget_fully_allocated) return null;

	return node.budget > node.allotted_budget + 1 ? "over" : "under";
};
